// Web stub for @capacitor/app — used when building for web/Docker
export const App = {
  addListener: () => Promise.resolve({ remove: () => {} }),
  removeAllListeners: () => Promise.resolve(),
  exitApp: () => {},
  getInfo: () => Promise.resolve({}),
  getState: () => Promise.resolve({ isActive: true }),
  getLaunchUrl: () => Promise.resolve(null),
};
